import React from 'react';
import { query, collection, doc, where, limit, } from 'firebase/firestore';
import { toast } from 'react-toastify';

import { getCollectionData, } from '../../firebase';
import { fields, } from '../../shared/models/productTag';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import ModelFormModal from '../modals/ModelFormModal';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import AddButton from '../AddButton';
import TenantPage from '../TenantPage';
import SettingsTabs from '../SettingsTabs';

export default function ProductTags (props) {
  return (
    <TenantPage>
      <PageContent {...props} />
    </TenantPage>
  );
};

function PageContent (props) {
  const { tenant, } = props;
  const productTags = useCollectionSubscription(query(collection(tenant.ref, 'productTags')));

  return (
    <div className="product-tags container-fluid">
      <div className="px-4">
        <div className="card p-4">
          <SettingsTabs activeTab="productTags" />
          <div className="mb-3 d-flex justify-content-start align-items-end gap-1">
            <AddButton
              itemRef={doc(collection(tenant.ref, 'productTags'))}
              FormModal={ModelFormModal}
              formProps={{ title: '商品タグ', fields: fields(), }}
            />
          </div>
          <table className="table table-bordered">
            <thead className="thead-light text-nowrap">
              <tr>
                <th style={{ minWidth: 250 }}>タグ名</th>
                <th style={{ minWidth: 70 }}></th>
              </tr>
            </thead>
            <tbody>
              {
                productTags.map(({ id, ref, name, }) => (
                  <tr key={id} id={id}>
                    <td>
                      {name}
                    </td>
                    <td>
                      <div className="text-nowrap d-flex justify-content-end gap-1">
                        <EditButton itemRef={ref} FormModal={ModelFormModal} formProps={{ title: '商品タグ', fields: fields(), }} />
                        <DeleteButton
                          itemRef={ref}
                          beforeDelete={async () => {
                            const products = await getCollectionData(
                              query(collection(tenant.ref, 'products'), where('tagIds', 'array-contains', id), limit(1))
                            );
                            if (products.length > 0) {
                              toast.error('このタグは商品に使用されているため削除できません');
                              return false;
                            }
                            return true;
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
